import { clsx } from 'clsx';
import { FC } from 'react';

import { Icon } from '@/general/Icons/Icon';
import type { IconName } from '@/general/Icons/sprite.generated';
import { formatNumber } from 'src/general/helpers/formatNumber';
import { BaseCarData } from 'src/types/Car.types';

interface Props {
  carData: BaseCarData;
  className?: string;
}

const carDetails: {
  title: string;
  iconName: IconName;
  valueKey: keyof BaseCarData;
  formatter?: (value: any) => string;
}[] = [
  {
    title: 'Odometer',
    iconName: 'meter',
    valueKey: 'kilometers',
    formatter: (value) => formatNumber(value, { append: ' km' }),
  },
  {
    title: 'Fuel type',
    iconName: 'petrol',
    valueKey: 'fuelType',
  },
  {
    title: 'Transmission',
    iconName: 'automatic-transmission',
    valueKey: 'transmission',
  },
];

export const CarPriceCardDetails: FC<Props> = ({ carData, className }) => (
  <dl className={clsx('mt-2 flex items-start justify-center gap-5', className)}>
    {carDetails.map(({ title, iconName, valueKey, formatter }) => (
      <div key={title} className="inline-flex items-center justify-start gap-0.5">
        <dt className="flex h-5 text-lg">
          <Icon name={iconName} size={20} />
        </dt>
        <dd className="c-fs-caption m-0 font-normal">{formatter ? formatter(carData[valueKey]) : carData[valueKey]}</dd>
      </div>
    ))}
  </dl>
);
